/** Permanently deletes a line added for this visit; only offered once that line has been excluded. */
import { PlannedItemCommandId, PlannedItemLine } from '@jms/model';
import { Command } from '@workbuddy/ui/model';
import { plannedItemRowAction } from './planned.item.command.support';

export const plannedItemRemoveRowCommand = (line: PlannedItemLine, onSaved?: () => void): Command => plannedItemRowAction(PlannedItemCommandId.Remove, line, onSaved);
